import ListController from "@/core/ListController";

export default class MedicamentWriteoffActsListController extends ListController {
  constructor(public name: string, public params: any = {}, public grid: any = null) {
    super(name, params);
  }

  setup() {
    const setup = super.setup();
    if (setup.config) {
      setup.config.localStorageKey = "medicament_writeoff_acts_grid_settings";
      setup.config.sorting = true;
    }
    return setup;
  }

  setButtons() {
    const grid = this.grid?.value;
    if (!grid || !grid.controller) return;

    const panelFun: any = [];
    panelFun.push({
      edit: this.store.accessRead() ? {} : null,
      add: this.store.accessCreate() ? {} : null,
      copy: this.store.accessCreate() ? {} : null,
      delete: this.store.accessDelete() ? {} : null,
    });
    grid.controller.createPanelFun(panelFun);
  }
}
